import { useEffect, useRef } from 'react';
import { useSendAnalyticsEvent } from './use-send-event';
import { safeLocalStorage } from 'src/utils/local-storage';

const STORAGE_KEY = 'pvo_microsite_visited';
const STORAGE_TIMESTAMP_KEY = 'pvo_microsite_last_visit';

export const useMicrositeAnalytics = () => {
  const { sendEvent } = useSendAnalyticsEvent();
  const hasTrackedEnter = useRef(false);

  useEffect(() => {
    if (hasTrackedEnter.current) return;

    const hasVisited = safeLocalStorage.getItem(STORAGE_KEY) === 'true';
    const now = Date.now();

    if (hasVisited) {
      sendEvent('pvo_microsite_reenter');
    } else {
      sendEvent('pvo_microsite_enter');
      safeLocalStorage.setItem(STORAGE_KEY, 'true');
    }

    safeLocalStorage.setItem(STORAGE_TIMESTAMP_KEY, now.toString());

    hasTrackedEnter.current = true;
  }, [sendEvent]);
};
